import script from "./RecipeExample.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeExample.vue?vue&type=script&setup=true&lang=js"

import "./RecipeExample.vue?vue&type=style&index=0&id=6bdaa8ee&lang=css"

const __exports__ = script;

export default __exports__